import { API_VERSIONS, JSON_ENCODED } from '@oup/shared-node-browser/constants';
import signedFetch from '../util/signedFetch.js';

export default data =>
  signedFetch('searchUserAssignments', `${__API_BASE__}/userAssignments/query`, 'POST', data, {
    Accept: API_VERSIONS.API_VERSION_0_2,
    'Content-Type': JSON_ENCODED
  });
